import React, { useState, useEffect, useContext, useRef } from 'react';
import './FacilityReports.css';
import baseApi from '../../common/api/base';
import Card from '../Card/Card';
import CardContent from '../Card/CardContent';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import { CardReportsContext } from '../../contexts/CardReportsContext';
import FacilityReportsContent from './FacilityReportContent';
import FacilityReportLoadingStatus from './FacilityReportLoadingStatus';
import logComponent from '../../common/logComponent';

export default function FacilityReports({ moduleDescription }) {
  const environmentContext = useContext(EnvironmentContext);
  const cardReportsContext = useContext(CardReportsContext);

  const [cardTitle, setCardTitle] = useState('Reports' );
  const { hasToken } = environmentContext;
  const loadingRef = useRef(false);

  const setLoadingRef = (el) => {
    if (logComponent('Reports')) { console.debug('Reports setLoadingRef'); }
    loadingRef.current = el;
  }


  useEffect(() => {
    if (logComponent('FacilityReports')) {console.debug('FacilityReports onMount'); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (!hasToken) return;
  }, []);

  useEffect(() => {
    if (logComponent('FacilityReports')) {console.debug('FacilityReports useEffect [environmentContext.hasToken]'); }
    if (!hasToken) return;

    loadReports();
  }, [environmentContext.hasToken]);


  useEffect(() => {
    if (logComponent('FacilityReports')) {console.debug('FacilityReports useEffect [environmentContext.organization, getCardTitle]'); }
    const { hasToken, activeUser: user, organization } = environmentContext;
    if (!hasToken) return;

    let newReportTitle = 'Reports';
    if (user && user.groupTypeString === 'Status Solutions') {
      newReportTitle = 'Status Solutions reports';
    }
    if (user && organization && user.groupTypeString === 'Corporate' || user.groupTypeString === 'Facility') {
      newReportTitle = `${organization.name} reports`;
    }


    setCardTitle(newReportTitle);
  }, [environmentContext.organization, environmentContext.activeUser]);

  

  const loadReports = () => {
    if (logComponent('FacilityReports')) {console.debug('FacilityReports loadReports'); }
    if (!hasToken || loadingRef.current) return;
    setLoadingRef(true);
    const { setReports, setReportsLoading, setReportsError } = cardReportsContext;

    setReports(null);
    setReportsLoading(true);
    setReportsError(false);


    baseApi.Reports.get()
      .then(
        results => {

          setReports(results.data);
          setReportsLoading(false);
          setReportsError(false);
          setLoadingRef(false);
        },
        error => {
          setReports(null);
          setReportsError(true);
          setReportsLoading(false);
          setLoadingRef(false);
        }
      );
  }


  return (
    <Card className="Facility-Reports" title={cardTitle} moduleDescription={moduleDescription} icon="clipboard-list" >
      <CardContent>
        <FacilityReportsContent />
        <FacilityReportLoadingStatus reloadAction={ loadReports } />
      </CardContent>
    </Card>
  )
}